module.exports = __webpack_public_path__ + "static/media/select-box.cca620b1.svg";